import React, { useMemo } from 'react';
import { ActionCreateTaskList } from '../../../../../modules/action-create/task-list';
import TaskItem from '../../../../../modules/action-create/components/task-item/task-item';
import { useLavvaCreateActionContext } from '../context';
import { useActionTasks } from '../hooks/use-action-tasks';
import { Task } from '../types';

const LavvaActionCreateTaskList: React.FC = () => {
  const { taskList } = useLavvaCreateActionContext();
  const { addNewTask, handleSubmit } = useActionTasks();

  const tasks = useMemo(() => taskList.map((task: Task) => <TaskItem key={task.id} task={task} />), [taskList]);

  return (
    <ActionCreateTaskList
      handleSubmit={handleSubmit}
      addNewTask={addNewTask}
      tasks={tasks}
      taskListLength={taskList.length}
    />
  );
};

export default LavvaActionCreateTaskList;
